/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './popup-dialog.component.css.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../$$_gendir/node_modules/@progress/kendo-angular-dialog/dist/es2015/index.ngfactory';
import * as i3 from '@progress/kendo-angular-l10n';
import * as i4 from '@progress/kendo-angular-dialog';
import * as i5 from '@angular/common';
import * as i6 from '../../../../app/components/anon/popup-dialog.component';
import * as i7 from '@angular/router';
import * as i8 from '../../../../app/services/auth/auth.service';
import * as i9 from '../../../../app/services/lookups/lookup.service';
import * as i10 from '../../../../app/services/lookups/user-agreement.service';
const styles_PopUpDialogComponent:any[] = [i0.styles];
export const RenderType_PopUpDialogComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_PopUpDialogComponent,data:{}});
function View_PopUpDialogComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'a',[['style',
      'cursor:pointer;']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.open('dialog')) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['Terms of Service']))],
      (null as any),(null as any));
}
function View_PopUpDialogComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),21,'kendo-dialog',
      [['title','Terms of Service']],[[1,'dir',0],[1,'tabIndex',0],[2,'k-dialog-wrapper',
          (null as any)]],[[(null as any),'close'],[(null as any),'keydown']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,3).onComponentKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('close' === en)) {
          const pd_1:any = ((<any>_co.close('dialog')) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_DialogComponent_0,i2.RenderType_DialogComponent)),i1.ɵprd(256,(null as any),
      i3.L10N_PREFIX,'kendo.dialog',([] as any[])),i1.ɵprd(131584,(null as any),i3.LocalizationService,
      i3.LocalizationService,[i3.L10N_PREFIX,[2,i3.MessageService],[2,i3.RTL]]),i1.ɵdid(5488640,
      (null as any),1,i4.DialogComponent,[i1.ElementRef,i1.Renderer2,i3.LocalizationService],
      {title:[0,'title']},{close:'close'}),i1.ɵqud(335544320,1,{titlebarContent:0}),
      (_l()(),i1.ɵted(1,['\n\n    '])),(_l()(),i1.ɵeld(0,(null as any),1,14,'article',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),4,'header',[['class','entry-header']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h2',[['class',
          'text-center']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['TERMS OF SERVICE AGREEMENT for YUDRIV PORTAL'])),
      (_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted((null as any),['\n      '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),0,'hr',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n      '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'div',[['class',
          'entry-content']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),0,'div',([] as any[]),[[8,'innerHTML',1]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n      '])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted(1,
          ['\n\n  ']))],(_ck,_v) => {
    const currVal_3:any = 'Terms of Service';
    _ck(_v,3,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵnov(_v,3).dir;
    const currVal_1:any = i1.ɵnov(_v,3).tabIndex;
    const currVal_2:any = i1.ɵnov(_v,3).wrapperClass;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = _co.termsOfServiceHTML;
    _ck(_v,18,0,currVal_4);
  });
}
export function View_PopUpDialogComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'div',[['class',
      'wrapper'],['style','display: inline;']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PopUpDialogComponent_1)),
      i1.ɵdid(16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PopUpDialogComponent_2)),
      i1.ɵdid(16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i6.PopUpDialogComponent = _v.component;
    const currVal_0:boolean = !_co.dialogOpened;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _co.dialogOpened;
    _ck(_v,6,0,currVal_1);
  },(null as any));
}
export function View_PopUpDialogComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-dialog',([] as any[]),
      (null as any),(null as any),(null as any),View_PopUpDialogComponent_0,RenderType_PopUpDialogComponent)),
      i1.ɵdid(114688,(null as any),0,i6.PopUpDialogComponent,[i7.Router,i8.AuthService,
          i9.LookupService,i10.UserAgreementService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const PopUpDialogComponentNgFactory:i1.ComponentFactory<i6.PopUpDialogComponent> = i1.ɵccf('app-dialog',
    i6.PopUpDialogComponent,View_PopUpDialogComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9zcmMvYXBwL2NvbXBvbmVudHMvYW5vbi9wb3B1cC1kaWFsb2cuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2M6L1Byb2plY3RzL1l1RFJJVi9TZXJ2aWNlc0FQSS9ZdURyaXYtU2VydmljZXNBUEkvRW5mb3JjZW1lbnQvc3JjL2FwcC9jb21wb25lbnRzL2Fub24vcG9wdXAtZGlhbG9nLmNvbXBvbmVudC50cyIsIm5nOi8vL2M6L1Byb2plY3RzL1l1RFJJVi9TZXJ2aWNlc0FQSS9ZdURyaXYtU2VydmljZXNBUEkvRW5mb3JjZW1lbnQvc3JjL2FwcC9jb21wb25lbnRzL2Fub24vcG9wdXAtZGlhbG9nLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9zcmMvYXBwL2NvbXBvbmVudHMvYW5vbi9wb3B1cC1kaWFsb2cuY29tcG9uZW50LnRzLlBvcFVwRGlhbG9nQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cIndyYXBwZXJcIiBzdHlsZT1cImRpc3BsYXk6IGlubGluZTtcIj5cclxuICA8YSAqbmdJZj1cIiFkaWFsb2dPcGVuZWRcIiAoY2xpY2spPVwib3BlbignZGlhbG9nJylcIiBzdHlsZT1cImN1cnNvcjpwb2ludGVyO1wiPlRlcm1zIG9mIFNlcnZpY2U8L2E+XHJcbiAgPGtlbmRvLWRpYWxvZyB0aXRsZT1cIlRlcm1zIG9mIFNlcnZpY2VcIiAqbmdJZj1cImRpYWxvZ09wZW5lZFwiIChjbG9zZSk9XCJjbG9zZSgnZGlhbG9nJylcIj5cclxuXHJcbiAgICA8YXJ0aWNsZT5cclxuICAgICAgPGhlYWRlciBjbGFzcz1cImVudHJ5LWhlYWRlclwiPlxyXG4gICAgICAgIDxoMiBjbGFzcz1cInRleHQtY2VudGVyXCI+VEVSTVMgT0YgU0VSVklDRSBBR1JFRU1FTlQgZm9yIFlVRFJJViBQT1JUQUw8L2gyPlxyXG4gICAgICA8L2hlYWRlcj5cclxuICAgICAgPGhyIC8+XHJcbiAgICAgIDxkaXYgY2xhc3M9XCJlbnRyeS1jb250ZW50XCI+XHJcbiAgICAgICAgPGRpdiBbaW5uZXJIVE1MXT1cInRlcm1zT2ZTZXJ2aWNlSFRNTFwiPjwvZGl2PlxyXG4gICAgICA8L2Rpdj5cclxuICAgIDwvYXJ0aWNsZT5cclxuXHJcbiAgPC9rZW5kby1kaWFsb2c+XHJcbjwvZGl2PlxyXG4iLCI8YXBwLWRpYWxvZz48L2FwcC1kaWFsb2c+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ0U7TUFBQTtJQUFBO0lBQUE7SUFBeUI7TUFBQTtNQUFBO0lBQUE7SUFBekI7RUFBQSxnQ0FBMEU7Ozs7b0JBQzFFO01BQUE7VUFBQTttQkFBQTtRQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUE0RDtVQUFBO1VBQUE7UUFBQTtRQUE1RDtNQUFBO3FCQUFBOzZCQUFBLDBEQUFBO01BQUE7TUFBQTtNQUFzRixpQ0FFcEY7VUFBQTtNQUFTLDZDQUNQO1VBQUE7VUFBQSw0Q0FBNkI7VUFBQSxpQkFDM0I7VUFBQTtVQUFBLGdCQUF3QjtNQUFpRCw2Q0FDbEU7TUFDVDtVQUFBLDBEQUFNO1VBQUEsZUFDTjtVQUFBO1VBQUEsZ0JBQTJCLCtDQUN6QjtVQUFBO1VBQUEsNENBQTRDO1VBQUEsZUFDeEMsMkNBQ0U7VUFBQTtJQVZFO0lBQWQsV0FBYyxTQUFkOzs7SUFBQTtJQUFBO0lBQUE7SUFBQSxXQUFBLDZCQUFBO0lBUVc7SUFBTCxZQUFLLFNBQUw7Ozs7b0JBVlI7TUFBQTtNQUFBLDhCQUE4Qyx5Q0FDNUM7YUFBQTthQUFBO1VBQUEsd0JBQThGLHlDQUM5RjtpQkFBQTthQUFBO1VBQUEsd0JBWWUsdUNBQ1g7VUFBQTs7SUFkRDtJQUFILFdBQUcsU0FBSDtJQUN1QztJQUF2QyxXQUF1QyxTQUF2Qzs7OztvQkNGRjtNQUFBO2FBQUE7bURBQUE7O1FBQUE7Ozs7In0=



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/$$_gendir/app/components/anon/popup-dialog.component.ngfactory.ts